<template>
	<el-dialog
		title="请选择登录企业"
		:visible.sync="dialogVisible"
		width="560px"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		:show-close="false"
		append-to-body
		center
		custom-class="change-company-dialog"
	>
		<div class="cc-body">
			<p class="cc-tip">您的账号关联了多个企业，请选择需要登录的企业</p>

			<div class="company-list">
				<div
					v-for="item in companies"
					:key="item.id"
					class="company-card"
					:class="{ 'is-selected': selectedId === item.id }"
					@click="selectedId = item.id"
				>
					<!-- 公司logo/图标 -->
					<div class="company-logo">
						<img v-if="item.logo" :src="item.logo" class="logo-img" />
						<i v-else class="el-icon-office-building logo-icon"></i>
					</div>

					<!-- 公司信息 -->
					<div class="company-info">
						<div class="company-name">{{ item.corporateName }}</div>
						<div class="company-meta">
							<el-tag v-if="item.role" size="mini" :type="item.isMain == 1 ? 'primary' : 'info'" effect="plain">
								{{ item.role }}
							</el-tag>
							<span v-if="item.companyCode" class="company-code">{{ item.companyCode }}</span>
						</div>
					</div>

					<!-- 选中标志 -->
					<div class="check-mark" v-if="selectedId === item.id">
						<i class="el-icon-check"></i>
					</div>
				</div>
			</div>
		</div>

		<div slot="footer" class="cc-footer">
			<el-button
				type="primary"
				size="medium"
				:disabled="!selectedId"
				class="confirm-btn"
				@click="handleConfirm"
			>
				进入企业
			</el-button>
		</div>
	</el-dialog>
</template>

<script>
export default {
	name: 'ChangeCompany',
	data() {
		return {
			dialogVisible: false,
			selectedId: null,
			companies: []
		};
	},
	methods: {
		// 打开弹窗，传入公司列表
		open(companies = []) {
			this.companies = companies;
			// 默认选中第一个企业
			this.selectedId = companies.length > 0 ? companies[0].id : null;
			this.dialogVisible = true;
		},

		// 确认选择
		handleConfirm() {
			const selected = this.companies.find(c => c.id === this.selectedId);
			if (!selected) return;
			this.$emit('selected', selected);
			this.dialogVisible = false;
		}
	}
};
</script>

<style lang="less" scoped>
.cc-body {
	padding: 0 4px;
}

.cc-tip {
	font-size: 13px;
	color: #909399;
	text-align: center;
	margin: 0 0 20px;
}

/* ===== 公司列表 ===== */
.company-list {
	display: flex;
	flex-direction: column;
	gap: 10px;
	max-height: 360px;
	overflow-y: auto;
}

/* ===== 公司卡片 ===== */
.company-card {
	display: flex;
	align-items: center;
	gap: 14px;
	padding: 14px 16px;
	border: 1px solid #e8ecf5;
	border-radius: 8px;
	cursor: pointer;
	transition: all 0.2s ease;
	background: #fff;
	position: relative;

	&:hover {
		border-color: #a0cfff;
		background: #f5f9ff;
	}

	&.is-selected {
		border-color: #409eff;
		background: #ecf5ff;
		box-shadow: 0 0 0 1px #409eff inset;
	}
}

/* ===== 公司图标 ===== */
.company-logo {
	flex-shrink: 0;
	width: 46px;
	height: 46px;
	border-radius: 8px;
	background: linear-gradient(135deg, #409eff, #79bbff);
	display: flex;
	align-items: center;
	justify-content: center;
	overflow: hidden;

	.logo-img {
		width: 100%;
		height: 100%;
		object-fit: cover;
	}

	.logo-icon {
		font-size: 22px;
		color: #fff;
	}
}

/* ===== 公司信息 ===== */
.company-info {
	flex: 1;
	min-width: 0;
}

.company-name {
	font-size: 15px;
	font-weight: 500;
	color: #1a1f2e;
	margin-bottom: 5px;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.company-meta {
	display: flex;
	align-items: center;
	gap: 8px;
}

.company-code {
	font-size: 12px;
	color: #909399;
}

/* ===== 选中标志 ===== */
.check-mark {
	flex-shrink: 0;
	width: 22px;
	height: 22px;
	border-radius: 50%;
	background: #409eff;
	display: flex;
	align-items: center;
	justify-content: center;

	i {
		font-size: 13px;
		color: #fff;
		font-weight: 700;
	}
}

/* ===== 底部按钮 ===== */
.cc-footer {
	text-align: center;

	.confirm-btn {
		min-width: 160px;
		height: 40px;
		font-size: 15px;
		letter-spacing: 1px;
	}
}

/* ===== 弹窗样式重置 ===== */
/deep/ .change-company-dialog {
	border-radius: 10px;
	overflow: hidden;

	.el-dialog__header {
		background: #f5f7fa;
		border-bottom: 1px solid #e8ecf5;
		padding: 18px 24px;

		.el-dialog__title {
			font-size: 16px;
			font-weight: 600;
			color: #1a1f2e;
		}
	}

	.el-dialog__body {
		padding: 24px;
	}

	.el-dialog__footer {
		border-top: 1px solid #e8ecf5;
		padding: 16px 24px;
	}
}
</style>
